import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Currency} from "@pg-rp/common-types";

import {NewsletterFlowWithRegistrationTrigger} from "../../../newsletter/components/NewsletterFlowWithRegistrationTrigger";
import {formatRecentFilterText} from "../../../search/utils/format_recent_filter_text";
import {useAppSelector} from "../../../store/hooks";
import {EmptyList} from "../../atoms/EmptyList";

interface Props {
    className?: string;
    useHeader?: boolean;
}

export const EmptyListWithNewsLetter = (props: Props) => {
    const searchData = useAppSelector((state) => state.search.formValues);
    const {search, ...restFilters} = searchData;
    const filtersString = formatRecentFilterText({filters: restFilters, currency: search.regions?.[0]?.currency || Currency.PLN});
    const subHeading = `${search.regions?.[0] ? search.regions[0].name : ""}${filtersString && filtersString.trim() !== "" ? `, ${filtersString}` : ""}`;

    return (
        <EmptyList
            heading="Nie znaleźliśmy ofert spełniających wybrane kryteria"
            subHeading={subHeading}
            additionalContent={
                <NewsletterFlowWithRegistrationTrigger
                    customButton={({onClick}) => (
                        <Button variant="filled_primary" className={btnStyle} onClick={() => onClick()}>
                            powiadom, kiedy się pojawią
                        </Button>
                    )}
                />
            }
            className={props.className}
            useHeader={props.useHeader}
        />
    );
};

const btnStyle = css({
    mt: 3,

    md: {
        mt: 5
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Currency} from "@pg-rp/common-types";

import {NewsletterFlowWithRegistrationTrigger} from "../../../newsletter/components/NewsletterFlowWithRegistrationTrigger";
import {formatRecentFilterText} from "../../../search/utils/format_recent_filter_text";
import {useAppSelector} from "../../../store/hooks";
import {EmptyList} from "../../atoms/EmptyList";

interface Props {
    className?: string;
    useHeader?: boolean;
}

export const EmptyListWithNewsLetter = (props: Props) => {
    const searchData = useAppSelector((state) => state.search.formValues);
    const {search, ...restFilters} = searchData;
    const filtersString = formatRecentFilterText({filters: restFilters, currency: search.regions?.[0]?.currency || Currency.PLN});
    const subHeading = `${search.regions?.[0] ? search.regions[0].name : ""}${filtersString && filtersString.trim() !== "" ? `, ${filtersString}` : ""}`;

    return (
        <EmptyList
            heading="Nie znaleźliśmy ofert spełniających wybrane kryteria"
            subHeading={subHeading}
            additionalContent={
                <NewsletterFlowWithRegistrationTrigger
                    customButton={({onClick}) => (
                        <Button variant="filled_primary" className={btnStyle} onClick={() => onClick()}>
                            powiadom, kiedy się pojawią
                        </Button>
                    )}
                />
            }
            className={props.className}
            useHeader={props.useHeader}
        />
    );
};

const btnStyle = css({
    mt: 3,

    md: {
        mt: 5
    }
});
